// Shared status-cycle helpers for ComponentList. Lifted out of
// ComponentList.tsx during the 2026-05-01 split.

import type { ComponentInspectionStatus } from '@/api/inspections';
import type { InspectionStatus } from '@/ui';

// IN/NI/NP/O — O is derived at read time from findings count and never stored;
// keep the cycle to the three persisted states + pending (null).
export const STATUS_CYCLE: ComponentInspectionStatus[] = [
  null,
  'inspected',
  'not_inspected',
  'not_present',
];

export const STATUS_TITLE: Record<InspectionStatus, string> = {
  IN:      'Inspected',
  NI:      'Not inspected',
  NP:      'Not present',
  O:       'Inspected — has findings',
  pending: 'Tap to cycle: Inspected → Not inspected → Not present',
};

export function resolveStatus(
  status: ComponentInspectionStatus,
  findingsCount: number,
): InspectionStatus {
  if (findingsCount > 0) return 'O';
  if (status === 'inspected') return 'IN';
  if (status === 'not_inspected') return 'NI';
  if (status === 'not_present') return 'NP';
  return 'pending';
}

export function nextStatus(status: ComponentInspectionStatus): ComponentInspectionStatus {
  const idx = STATUS_CYCLE.indexOf(status);
  return STATUS_CYCLE[(idx + 1) % STATUS_CYCLE.length];
}
